/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Typography from './Typography';

import styles from '../../styles/typography/section-description.module.css';

const propTypes = {
    tag: PropTypes.string,
    brand: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    tag: 'h4',
    brand: null,
    className: null,
};

function SectionDescription({ tag, brand, className, ...props }) {
    return (
        <Typography
            tag={tag}
            className={classNames([
                styles.container,
                {
                    [styles[brand]]: className !== null,
                    [className]: className !== null,
                },
            ])}
            {...props}
        />
    );
}

SectionDescription.propTypes = propTypes;
SectionDescription.defaultProps = defaultProps;

export default SectionDescription;
